import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Quote from "components/Typography/Quote.jsx";
// core components

import SectionDestacadas from "KComponents/SectionDestacadas.jsx";
import SectionRecents from "KComponents/SectionRecents.jsx";

import sectionTextStyle from "assets/jss/material-kit-pro-react/views/blogPostSections/sectionTextStyle.jsx";

function SectionText({ ...props }) {
  const { classes } = props;
  const { featured } = props;
  const { recents } = props;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            Our team provides leasing, acquisition, consultancy and investment advice to retailers and owners throughout the Spain
          </h3>
          <p>
            Operating out of nine offices across the country, our cross-sector team are experts in their local retail markets, applying their knowledge to each individual project and client,
            covering everything from shopping centres to high street retail, and from supermarkets to retail parks.
            In a fast-evolving sector that continues to be reshaped by consumer demand, our team knows the importance of keeping up with its developments.
            From in-town and out-of-town schemes, to high street, warehousing and single stores, we cover all parts of the retail property sector in all areas of the Spain,
            operating from Madrid, Málaga and Barcelona
            The size of the team and geographical spread allows us to respond quickly to clients requirements on any scale of project, and also provide national
            scale expertise to deliver effectively and efficiently.
            We offer a bespoke, specialist service on all technical aspects of investment advice, acquisitions, disposals and lease consultancy throughout the Spain
            providing a link to Europe, as well as extending our global network.
            RETAIL
          </p>
          <Quote
            textClassName={classes.quoteText}
            text="“Excellence is our Goal, customers satisfaction our proud!”"
            author="Joaquín Morales, CEO."
          />
        </GridItem>
        <GridItem xs={12} sm={10} md={10} className={classes.section}>
          <SectionDestacadas featured= {recents} url="retail" />
          <SectionRecents recents= {recents} url="retail" />
        </GridItem>

        <GridItem xs={12} sm={8} md={8} id="search" >
        </GridItem>

      </GridContainer>
    </div>
  );
}

export default withStyles(sectionTextStyle)(SectionText);
